import { render, staticRenderFns } from "./ModalModificarUsuario.vue?vue&type=template&id=18124e81"
import script from "./ModalModificarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalModificarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports